var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-wrap align-center az-gap-xsmall az-ds-aux" },
    _vm._l(_vm.items, function(item, index) {
      return _c(
        "span",
        { key: item.key, staticClass: "d-inline-flex align-center" },
        [
          index > 0
            ? _c("span", { staticClass: "mr-1" }, [_vm._v("·")])
            : _vm._e(),
          item.icon
            ? _c("icon-svg", {
                staticClass: "mr-1",
                attrs: { name: item.icon, size: 14 }
              })
            : _vm._e(),
          _c("span", [_vm._v(_vm._s(item.text))])
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }